import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-image-modal-view',
  templateUrl: './image-modal-view.component.html',
  styleUrls: ['./image-modal-view.component.css']
})
export class ImageModalViewComponent implements OnInit {

  @Input() view_image_url: any;
  constructor() { }


  ngOnchange() {
    
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-modal-module/image-modal-view/image-modal-view.component.ts